import { createContext, useEffect, useReducer } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import { useSelector } from 'react-redux';
import Toast from '../../../Util/Toast/Toast';

const initialState = {
    serviceLetters: [],
    isLoading: false,
    isError: false
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
            return {
                ...state,
                isLoading: true,
                isError: false
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isError: false,
                serviceLetters: action.payload
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        default:
            return state;
    }
};

export const ServiceLetterContext = createContext();

const ServiceLetterProvider = ({ children }) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const [state, dispatch] = useReducer(reducer, initialState);

    const pdc_project_id = sessionSelector.pdc_project_id;

    const fetchServiceLetters = async () => {
        try {

            dispatch({ type: 'FETCH_INIT' });

            const response = await Fetch.post(
                config.endpoints.backend + 'portal/servicecharters',
                {
                    filter: {
                        pdc_project_id
                    }
                }
            );

            if (!Array.isArray(response)) {
                throw new Error('Erro ao buscar cartas de serviço');
            }

            dispatch({ type: 'FETCH_SUCCESS', payload: response });

        } catch (error) {
            Toast.error('Erro ao buscar cartas de serviço');
            dispatch({ type: 'FETCH_FAILURE' });
        }
    };

    useEffect(() => {
        fetchServiceLetters();
    }, [pdc_project_id]);

    return (
        <ServiceLetterContext.Provider
            value={{
                state
            }}
        >
            {children}
        </ServiceLetterContext.Provider>
    );
};

export default ServiceLetterProvider;
